import { color } from 'styles/colors'

export const ExportGraphAsImage = (plotlyDiv, canvas, fileName, chartTitle) => {
  if (plotlyDiv && canvas) {
    const graphDiv = plotlyDiv?.cloneNode(true) as HTMLElement
    const images = graphDiv.querySelectorAll('image')

    const promises: Array<Promise<void>> = []
    images.forEach(image => {
      const href = image.getAttribute('href')
      if (href !== null) {
        promises.push(
          fetch(href)
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok')
              }
              return response.blob()
            })
            .then(blob => {
              return new Promise((resolve) => {
                const reader = new FileReader()
                reader.onloadend = () => {
                  resolve(reader.result)
                }

                reader.readAsDataURL(blob) // Convert to Base64graphDiv
              })
            })
            .then((base64data: string) => {
              image.setAttribute('href', base64data) // Update href with Base64
            })
            .catch(error => console.error('Error fetching image:', error))
        )
      }
    })

    const svgs = graphDiv.getElementsByClassName('main-svg')
    const chartInfoLayer = graphDiv.getElementsByClassName('infolayer')

    const title = document.createElementNS('http://www.w3.org/2000/svg', 'text')
    title.classList.add('gtitle')
    title.textContent = chartTitle
    title.setAttribute('text-anchor', 'middle')
    title.setAttribute('x', (plotlyDiv.clientWidth / 2).toString())
    title.setAttribute('y', '25')

    title.style.fontFamily = 'Inter, sans-serif'
    title.style.fontSize = '15px'
    title.style.fill = `${color('headerText')}`

    const titleholder = document.createElementNS('http://www.w3.org/2000/svg', 'g')
    titleholder.classList.add('g-gtitle')
    titleholder.appendChild(title)

    if (chartInfoLayer.length > 0 && svgs.length > 0) {
      chartInfoLayer[0].appendChild(titleholder)
      svgs[0].appendChild(chartInfoLayer[0])
    }

    Promise.all(promises)
      .then(() => {
        const svgBlob = new Blob([svgs[0].outerHTML], { type: 'image/svg+xml;charset=utf-8' })
        const url = URL.createObjectURL(svgBlob)
        const img = new Image()

        img.onload = () => {
          const ctx = canvas.getContext('2d')
          canvas.width = plotlyDiv.clientWidth // Set canvas width
          canvas.height = plotlyDiv.clientHeight // Set canvas height

          // Draw the SVG image onto the canvas
          ctx?.clearRect(0, 0, canvas.width, canvas.height) // Clear the canvas
          ctx?.drawImage(img, 0, 0)

          // Create a PNG image from the canvas
          const pngUrl = canvas.toDataURL('image/png')

          // Create a link and set the URL to the PNG image
          const link = document.createElement('a')
          link.href = pngUrl
          link.download = fileName // Set the default file name
          document.body.appendChild(link)
          link.click() // Trigger the download
          document.body.removeChild(link) // Clean up

          URL.revokeObjectURL(url) // Free memory
        }

        img.src = url // Set the image source to the Blob URL
      })
  }
}
